import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Kicker, H2 } from './ui/Typography';
import { useT } from '../i18n/LanguageContext';
export function MechanismSection() {
  const t = useT().mechanism;
  return <Section hasOrb={false} data-id="element-108">
      <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-109">
        <div className="flex justify-center" data-id="element-110">
          <Kicker data-id="element-111">{t.kicker}</Kicker>
        </div>
        <H2 data-id="element-112">{t.title}</H2>
        <p className="text-ink-dim text-xl max-w-2xl mx-auto" data-id="element-113">{t.subtitle}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto relative" data-id="element-114">
        <div className="hidden md:flex absolute inset-0 items-center justify-evenly pointer-events-none z-10" data-id="element-115">
          <span className="font-archivo text-brand text-4xl opacity-50 translate-x-[-15px]" data-id="element-116">
            ×
          </span>
          <span className="font-archivo text-brand text-4xl opacity-50 translate-x-[15px]" data-id="element-117">
            ×
          </span>
        </div>

        {t.cards.map((card, i) => <Card key={i} delay={0.1 * (i + 1)} className="text-center" data-id="element-118">
            <h3 className="font-archivo text-2xl text-brand uppercase tracking-tight mb-4" data-id="element-119">
              {card.title}
            </h3>
            <p className="text-ink-dim" data-id="element-120">{card.desc}</p>
          </Card>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.01
    }} transition={{
      duration: 0.5,
      delay: 0.4
    }} className="max-w-3xl mx-auto mt-16 p-6 border border-border-strong bg-[rgba(250,255,0,0.02)] rounded-[10px] text-center" data-id="element-121">
        <p className="text-ink font-medium" data-id="element-122">{t.note}</p>
      </motion.div>
    </Section>;
}